<template>
  <div id="app">
    <!-- 返回顶部 -->
    <div class="return_Top" @click="backTop" v-show="btnFlag == true">
      <!-- <p class="el-icon-top"></p> -->
      <img src="../public/skypegmwcn_imgs/Partnership/zhiding.png" alt="" />
    </div>
    <!-- 导航栏 -->
    <div class="incenter box">
      <div :class="nav ? 'navgit navBox' : 'navList navBox'">
        <div class="logo">
          <img src="../public/skypegmwcn_imgs/Partnership/logo.png" alt="" />
          <!-- logo -->
        </div>
        <ul>
          <li>
            <router-link active-class="ona" to="/" exact>首页</router-link>
          </li>
          <!-- 二级 -->
          <li class="foxbase">
            <router-link to="/label" active-class="ona">多语言标注</router-link>
            <div :class="nav ? 'foxbase_nav' : 'fox_nav'">
              <p>
                <router-link active-class="ona" to="/label"
                  >标注服务</router-link
                >
              </p>
              <p>
                <router-link active-class="ona" to="/nebula"
                  >盘石星云</router-link
                >
              </p>
            </div>
          </li>
          <li>
            <router-link to="/talents" active-class="ona"
              >数据人才培训</router-link
            >
          </li>
          <li>
            <router-link to="/custom" active-class="ona"
              >数据标注定制服务</router-link
            >
          </li>
          <li>
            <router-link to="/ai" active-class="ona"
              >AI教育定制服务</router-link
            >
          </li>
          <li>
            <router-link to="/partnership" active-class="ona"
              >行业合伙人计划</router-link
            >
          </li>
          <li class="zoology_block">
            <router-link exact to="/ecology" active-class="ona"
              >盘石生态</router-link
            >
            <div :class="nav ? 'zoology_List' : 'box_nav'">
              <p class="en">
                <router-link active-class="ona" to="/ecology"
                  >企业介绍</router-link
                >
              </p>
              <p>
                <router-link active-class="ona" to="/journalism"
                  >新闻资讯</router-link
                >
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- main -->
    <router-view />

    <!-- footer -->
    <div class="footer">
      <div class="incenter">
        <div class="footer_logo">
          <img src="../public/skypegmwcn_imgs/Partnership/logoW.png" alt="" />
          <p>www.panshidata.com</p>
        </div>
        <div class="footer_Imgs">
          <div>
            <img src="../public/skypegmwcn_imgs/Partnership/gfwx.png" alt="" />
            <p>官方微信</p>
          </div>
          <div>
            <img src="../public/skypegmwcn_imgs/Partnership/gfgzh.png" alt="" />
            <p>官方公众号</p>
          </div>
        </div>
        <div class="footer_about">
          <p>关于我们</p>
          <router-link to="/ecology">企业介绍</router-link>
        </div>
        <div class="footer_relation">
          <p>联系我们</p>
          <ul>
            <li>
              <span>客服：024-23220068</span>
              <span>周一至周五 9:00 ~ 17:00</span>
            </li>
            <li>
              <span>邮箱：business@panshidata.com</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="footer_Footer">
      <div class="incenter">
        <p>
          <a href="https://beian.miit.gov.cn/" target="_blank">Copyright©2021 辽宁盘石数据科技有限公司版权所有 -辽ICP备2021004351号-1</a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      btnFlag: false,
      nav: true,
    };
  },
  methods: {
    // 定义全局动态方法

    isRam() {
      let h = window.screen.availHeight; // 获取浏览器可视窗口

      window.onscroll = () => {
        let list = document.querySelectorAll(".ram");
        list.forEach((ele) => {
          if (ele.getBoundingClientRect().top < h) {
            ele.classList.add("on");
          } else {
            ele.classList.remove("on");
          }
        });
      };
    },
    /* 返回顶部 */

    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    backTop() {
      const that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 10);
    },

    // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop() {
      const that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 60) {
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    },
    watchScroll() {
      // 滚动的距离
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      // 容器的高度
      var offsetTop = document.querySelector(".navBox").offsetHeight;

      // 滚动的距离如果大于了元素到顶部的距离时，实现吸顶效果
      if (scrollTop > offsetTop) {
        this.nav = false;
      } else {
        this.nav = true;
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.isRam);
    // this.isRam();
    // 吸顶

    // 移动端进入 关闭3d效果
    if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
      let nav = document.querySelector(".navgit");
      let navList = document.querySelector(".navList");
      nav.style.transform = " translateX(350px)";
      let arrList = document.querySelectorAll(".ram");
      arrList.forEach((ele) => {
        ele.classList.remove("ram");
      });
    } else {
      
      window.addEventListener("scroll", this.watchScroll);
    }

    // 返回顶部
    window.addEventListener("scroll", this.scrollToTop);
  },
  updated() {},
  computed: {
    isList() {
      return document.querySelectorAll(".ram");
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
// 吸顶
.navList {
  width: 99vw;
  height: 86px;
  background: #1d1d1f;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;

  img {
    margin-left: 100px;
    margin-top: 25px;
  }
  display: flex;
  justify-content: space-between;
  ul {
    margin-right: 128px;
    display: flex;
    width: 1000px;
    justify-content: space-between;

    .fox_nav,
    .box_nav {
      display: none;
      transform: translateX(-7px);
      height: 68px;
     border-radius: 0px 0px 10px 10px;
      background: #1d1d1f;
      box-shadow: 7px 10px 27px 0px rgba(255, 255, 255, 0.2);
      padding-top: 10px;
      p {
        margin-bottom: 10px;
        a {
          color: white;
        }
      }
    }
    .foxbase:hover {
      // margin-top: 35px;
      .fox_nav {
        width: 120%;
        display: block;
      }
      .ona {
        color: #ff8a00;
      }
    }
    .zoology_block:hover {
      .box_nav {
        display: block;
        width: 120%;
      }
      .ona {
        color: #ff8a00;
      }
    }

    li {
      > a {
        line-height: 86px;
        padding-bottom: 5px;
        transform: translateY(-20px);
      }
      .ona {
        color: #ff8a00;
      }
    }
  }
}
// 返回顶部
.return_Top {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 60px;
  position: fixed;
  top: 800px;
  right: 20px;
  z-index: 999;
  // background: rgba(0, 0, 0, 0.2);
  background: #fff;
  box-shadow: 4px 4px 57px 0px rgba(0, 0, 0, 0.11);
  border-radius: 100%;
  font-size: 20px;
  color: white;
  img {
    margin: 0 auto;
    margin-top: 23px;
    width: 30px;
    height: 35px;
  }
}
// 全局 title 样式
.title {
  img {
    margin: 0 auto;
  }
  p {
    height: 41px;
    font-size: 42px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #1d1d1f;
    line-height: 21px;
    transform: translateY(-35px);
  }
}

/* 全局动画效果 */

.ram {
  opacity: 0;
}
.on {
  opacity: 1;
  transition: all 1s ease 0s;
  transform: translate(0, -60px);
}

html,
body {
  width: 100%;
  height: 100%;
}
// 二级
.zoology_List {
  .en {
  }
  width: 120%;
  a {
    color: #000;
  }
  p {
    padding-top: 8px;
  }
  background: white;
  transform: translateX(-7px);
  margin-top: 5px;
  display: none;
  height: 80px;
  padding-bottom: 10px;
  border-radius: 10px;
}
.zoology_block:hover {
  .zoology_List {
    display: block;
  }
}
// 二级
.foxbase_nav {
  width: 100%;
  a {
    color: #000;
  }
  p {
    padding-top: 8px;
  }
  background: white;
  // transform: translateX(-7px);
  margin-top: 5px;
  display: none;
  height: 80px;
  padding-bottom: 10px;
  border-radius: 10px;
}
.foxbase:hover {
  .foxbase_nav {
    display: block;
  }
}
//  去掉全局默认样式
.typePage {
  width: 1450px;
  margin: 0 auto;
  background: orange;
}
* {
  margin: 0;
  padding: 0;
  list-style: none;
  img {
    display: block;
  }
  a {
    text-decoration: none;
    color: #ffffff;
  }
}
// 导航栏
.incenter {
  position: relative;
  width: 90vw;
  margin: 0 auto;
}
.navgit {
  width: 88vw;
  position: absolute;
  top: 36px;
  right: 128px;
  z-index: 999;
  transform: translateX(128px);
  ul {
    display: flex;
    float: right;
    line-height: 33px;
  }
  .logo {
    float: left;
  }

  div {
  }
  li {
    a {
      padding-bottom: 5px;
    }
    margin-left: 65px;
    padding-bottom: 2px;
  }
  .ona {
    color: #ff8a00;
  }
  // .active{
  //   color: white;
  //   background: #ff8a00;
  // }
}

// 底部

.footer {
  width: 99vw;
  display: block;
  margin: 0 auto;
  overflow: hidden;
  height: 247px;
  background: #1d1d1f;
  .incenter {
    width: 85vw;
    margin: 0 auto;
    margin-top: 50px;
    display: flex;
    justify-content: space-between;
    .footer_relation {
      margin-left: 100px;
      text-align: left;
      p {
        color: white;
        font-size: 24px;
        margin-bottom: 28px;
      }
      li span:nth-of-type(1) {
        margin-right: 50px;
      }
      li {
        margin-bottom: 28px;
      }
      span {
        color: #cccccc;
      }
    }
    .footer_about {
      color: white;
      text-align: left;
      margin-left: 10vw;
      p {
        margin-bottom: 28px;
        font-size: 24px;
      }
      a {
        color: #cccccc;
        font-size: 20px;
      }
      a:hover {
        color: #ff8a00;
      }
    }
    .footer_Imgs {
      color: white;
      display: flex;
      margin-left: 128px;
      div:nth-of-type(1) {
        margin-right: 93px;
      }
      p {
        line-height: 30px;
      }
    }
    .footer_logo {
      width: 320px;
      width: 319px;
      height: 25px;
      text-align: left;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 300;
      color: #ffffff;
      line-height: 24px;
      p {
        margin-top: 10px;
        letter-spacing: 2px;
      }
    }
  }
}
.footer_Footer {
  margin: 0 auto;
  height: 50px;
  width: 99vw;
  background: #1d1d1f;
  border-top: 1px solid #999;
  div {
    line-height: 50px;
    color: #cccccc;
    font-size: 14px;
  }
}

/* 响应式 */

@media all and (max-width: 1600px) {
  .incenter {
    width: 1460px;
  }
  .navgit {
    width: 1600px;
    transform: translateX(300px);
  }

  .footer_Footer {
    width: 1920px;
    overflow: none;
  }
  .footer_about {
    width: 150%;
  }
  // .navList{}
  .footer {
    width: 1920px;
    .incenter {
      width: 100%;
    }
  }
  .navList {
    transform: none;
    width: 1920px;
    margin: 0 auto;
  }
}
@media all and (max-width: 1200px) {
}
// 解决字体
@media all and (max-width: 1670px) {
  .footer {
    .incenter {
      width: 80%;
    }
  }
  .footer_about {
    width: 120px;
  }
}

// 移动端底部问题
@media all and (max-width: 900) {
  .footer {
    width: 100vw;
  }
}
</style>
